import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppErrorService } from './app-error.service';

export interface SystemToastPayload {
  title: string;
  message: string;
  durationMs?: number;
  fadeMs?: number;
}

@Injectable({ providedIn: 'root' })
export class SystemToastService {
  private readonly _toast$ = new BehaviorSubject<SystemToastPayload | null>(null);
  readonly toast$ = this._toast$.asObservable();

  constructor(private appErrorService: AppErrorService) {}

  show(payload: SystemToastPayload) {
    this._toast$.next({
      durationMs: 1800,
      fadeMs: 250,
      ...payload,
    });
  }

  showCode(code: string, title = 'Notice', overrides?: Partial<SystemToastPayload>) {
    this.show({
      title,
      message: this.appErrorService.getKnownMessage(code),
      ...overrides,
    });
  }

  clear() {
    this._toast$.next(null);
  }
}
